// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/libs/wechat-signature'
import 'lib-flexible'
import 'moment/locale/zh-cn'
import * as filters from './filters'
import './assets/style/style.css'
// import AlloyLever from 'alloyLever'

Vue.config.productionTip = false
window.eventBus = new Vue()// 注册全局事件对象

if (process.env.NODE_ENV === 'production') {
  /* eslint-disable no-use-before-define */
  router.afterEach((to, from, next) => {
    setTimeout(() => {
      const _hmt = _hmt || [];
      (function() {
        // 每次执行前，先移除上次插入的代码
        document.getElementById('baidu_bm') && document.getElementById('baidu_bm').remove()
        let hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?3b4ea29fb8eb8574f2d93977a5e2399a'
        hm.id = 'baidu_bm'
        let s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })();

      /* Talking Data */
      (function() {
        // 每次执行前，先移除上次插入的代码
        document.getElementById('td_bm') && document.getElementById('td_bm').remove()
        let hm = document.createElement('script')
        hm.src = 'https://jic.talkingdata.com/app/h5/v1?appid=F1B5AD11D2306A3C5E7C9F2426857E74'
        hm.id = 'td_bm'
        let s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }, 0)
  })
}

/* eslint-disable no-inner-declarations */
/* eslint-disable no-undef */
function trackingH5Event(eventId, label, params) {
  if (label && !isEmptyObject(params)) {
    TDAPP.onEvent(eventId, label, params)
  } else if (label) {
    TDAPP.onEvent(eventId, label)
  } else {
    TDAPP.onEvent(eventId)
  }
}
function isEmptyObject(obj) {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

Vue.prototype.trackingTD = function(eventId, label, params) {
  if (window.TDAPP && process.env.NODE_ENV === 'production') {
    trackingH5Event(eventId, label, params)
  }
}

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

// AlloyLever.config({
//   cdn: '//s.url.cn/qqun/qun/qqweb/m/qun/confession/js/vconsole.min.js', // vconsole的CDN地址
//   reportPrefix: 'bm-insure',
//   reportKey: 'msg',
//   otherReport: {
//     uin: 'banmaInsure'
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js